import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/assistant.png'


const _withScopeId = n => (_pushScopeId("data-v-06f3b596"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-pc last" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"width":"86px","height":"75px","cursor":"pointer"}
  })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "微信服务号", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "ub ub-ac ub-pc item" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("我要吐槽")
const _hoisted_6 = {
  key: 1,
  class: "ub ub-ver tips2 ub-as ub-pc theme-bg-color"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jiantou" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-ps fw title" }, "小提示", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-ps fw sub-title" }, "您可以在【帮助中心】找回您的小助手", -1))
const _hoisted_10 = { class: "ub ub-ac ub-pb footers" }

export function render(_ctx, _cache) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")
  const _component_TheFeedback = _resolveComponent("TheFeedback")
  const _component_a_menu = _resolveComponent("a-menu")
  const _component_a_dropdown = _resolveComponent("a-dropdown")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showAssistant)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "ub ub-ac ub-pc ub-ver assistant-div",
          style: _normalizeStyle(_ctx.style),
          ref: "el"
        }, [
          _createVNode(_component_a_dropdown, { placement: "top" }, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "ub ub-ac ub-pc item",
                        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.goVideo && _ctx.goVideo(...args)))
                      }, "新手课堂")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "ub ub-ac ub-pc item",
                        onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.displayWX && _ctx.displayWX(...args)))
                      }, _hoisted_3)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "ub ub-ac ub-pc item",
                        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.concatKefu && _ctx.concatKefu(...args)))
                      }, "联系客服")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "ub ub-ac ub-pc item",
                        onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.goVersion && _ctx.goVersion(...args)))
                      }, "版本更新")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_TheFeedback, { hideIcon: true }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "ub ub-ac ub-pc item",
                        onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
                      }, "关闭悬浮")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ], 4))
      : _createCommentVNode("", true),
    (_ctx.showTips)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "ub ub-ac ub-ps no-tips",
              onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.noAlert && _ctx.noAlert(...args)))
            }, "不再提醒"),
            _createElementVNode("div", {
              class: "ub ub-ac ub-pc btn",
              onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.close && _ctx.close(...args)))
            }, "知道了")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}